import React, { Fragment, useState } from 'react';
import { Row, Col, Table, Badge } from 'reactstrap';
import moment from 'moment';
import formatedDate from '../../../../../utilities/formatedDate';
import { getFromLocalStorage } from '../../../../../hooks/useLocalStorage';
import checkClientConfig from '../../../../../utilities/checkClientConfig';
import formatedDateOnly from '../../../../../utilities/formatedDateOnly';

const PolicyDetails = ({ data }) => {
    const [adminAllow] = useState(getFromLocalStorage('ROLE')?.key == "ADMIN" || getFromLocalStorage('ROLE')?.key == "TEAM_MEMBER" ? true : false);
    const [invoiceAllow] = useState(checkClientConfig("SEND_INVOICE_ATTACHMENT") ? true : false);

    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" className='pad-l-r-40 pad-b-0'>
                    <Table>
                        <tbody>
                            <tr>
                                <th>Policy Number</th>
                                <td>{data?.policy?.policy_no}</td>
                            </tr>
                            {/*  */}

                            {invoiceAllow || adminAllow ? (
                                <tr>
                                    <th>Invoice Number</th>
                                    <td>{data?.policy?.invoice_no}</td>
                                </tr>
                            ) : null}
                            <tr>
                                <th>Start Date</th>
                                <td>{data?.policy?.start_date && formatedDateOnly(data?.policy?.start_date)}</td>
                            </tr>
                            <tr>
                                <th>End Date</th>
                                <td>{data?.policy?.end_date && formatedDateOnly(data?.policy?.end_date)}</td>
                            </tr>

                            <tr>
                                <th>Created At</th>
                                {/* <td>{data?.policy?.created_at ? formatedDate(data?.policy?.created_at) : ''}</td> */}
                                <td>{data?.policy?.created_at ? formatedDateOnly(data?.policy?.created_at) : ''}</td>
                            </tr>
                            <tr>
                                <th>Created By</th>
                                <td>{data?.created_by_user || 'NA'}</td>
                            </tr>
                            <tr>
                                <th>Status</th>
                                <td>
                                    <Badge
                                        color={
                                            data?.policy?.status.toUpperCase() === 'ACTIVE'
                                                ? 'success'
                                                : data?.policy?.status.toUpperCase() === 'MODIFY_REQUESTED'
                                                    ? 'warning'
                                                    : data?.policy?.status.toUpperCase() === 'CANCELLATION_REQUESTED'
                                                        ? 'warning'
                                                        : data?.policy?.status.toUpperCase() === 'CANCELLED'
                                                            ? 'danger'
                                                            : 'default'
                                        }
                                    >
                                        {data?.policy?.status.toUpperCase()}
                                    </Badge>
                                </td>
                            </tr>
                            {data?.policy?.edit_reason && (
                                <tr>
                                    <th>Reason</th>
                                    <td>{data?.policy?.edit_reason}</td>
                                </tr>
                            )}
                            {data?.policy?.edit_remarks && (
                                <tr>
                                    <th>Remark</th>
                                    <td>{data?.policy?.edit_remarks}</td>
                                </tr>
                            )}
                            {data?.policy?.cancellation_reason && (
                                <tr>
                                    <th>Reason</th>
                                    <td>{data?.policy?.cancellation_reason}</td>
                                </tr>
                            )}
                            {data?.policy?.cancellation_remarks && (
                                <tr>
                                    <th>Remark</th>
                                    <td>{data?.policy?.cancellation_remarks}</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default PolicyDetails;